import {
	ButtonPropsSizeOverrides,
	ButtonPropsVariantOverrides
} from '@mui/material';
import React, { useCallback } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { LoadingButton } from '@mui/lab';
import { OverridableStringUnion } from '@mui/types';

interface IUploadButtonProps {
	inputName: string;
	text?: string;
	readFullFile?: boolean;
	loading?: boolean;
	iconOnly?: boolean;
	variant?: OverridableStringUnion<
		'text' | 'outlined' | 'contained',
		ButtonPropsVariantOverrides
	>;
	size?: OverridableStringUnion<
		'small' | 'medium' | 'large',
		ButtonPropsSizeOverrides
	>;
	accept?: string;
	onFileUpload: (data: string | ArrayBuffer) => void;
}

const UploadButton: React.FC<IUploadButtonProps> = ({
	inputName,
	text,
	readFullFile,
	loading,
	variant,
	size,
	accept,
	iconOnly,
	onFileUpload
}) => {
	const uploadFile = useCallback(
		(e: any) => {
			const file = e.target.files[0];
			if (file && readFullFile) {
				const fileReader = new FileReader();
				fileReader.readAsText(e.target.files[0], 'UTF-8');
				fileReader.onload = (readerEvent: any) => {
					if (readerEvent.target?.result) {
						onFileUpload(readerEvent.target?.result);
					}
				};
			} else {
				onFileUpload(file);
			}
		},
		[onFileUpload, readFullFile]
	);
	return (
		<label htmlFor={inputName} title={text}>
			<input
				id={inputName}
				data-testid={inputName}
				type="file"
				accept={accept}
				onChange={uploadFile}
				style={{
					display: 'none'
				}}
			/>
			<LoadingButton
				color="primary"
				aria-label={text}
				component="span"
				variant={variant}
				size={size}
				loading={loading}
				startIcon={!iconOnly && <FileUploadIcon />}
			>
				{iconOnly ? <FileUploadIcon /> : text}
			</LoadingButton>
		</label>
	);
};

UploadButton.defaultProps = {
	readFullFile: false,
	loading: false,
	variant: 'text',
	size: 'small',
	accept: '',
	iconOnly: false,
	text: undefined
};

export default UploadButton;
